import type { StateCreator } from "zustand"
import { create } from "@/app/state"

interface State {
  isOpen: boolean
  challengeId: string
  openModal: (challengeIdToDelete: string) => void
  closeModal: () => void
}

const state: StateCreator<State> = (set) => ({
  isOpen: false,
  challengeId: "",
  openModal: (challengeIdToDelete: string) =>
    set({ isOpen: true, challengeId: challengeIdToDelete }),
  closeModal: () => set({ isOpen: false, challengeId: "" }),
})

export const useDeleteChallengeModal = create<State>()(state)
